import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _Section_brand, _class2, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _SectionLink_brand, _class3, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _SidebarSectionForm_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateGetter(s, r, a) { return a(_assertClassBrand(s, r)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/* import __COLOCATED_TEMPLATE__ from './sidebar-section-form.hbs'; */
import { tracked } from "@glimmer/tracking";
let cached = esc(require('@glimmer/tracking')).cached;
import { A } from "@ember/array";
import Component, { setComponentTemplate } from "@ember/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { isEmpty } from "@ember/utils";
import { ajax } from "discourse/lib/ajax";
import { extractError } from "discourse/lib/ajax-error";
import { SIDEBAR_SECTION, SIDEBAR_URL } from "discourse/lib/constants";
import { sanitize } from "discourse/lib/text";
import { afterRender, bind } from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
import esc from "../../../../../../../../../node_modules/@embroider/macros/src/addon/es-compat2";
import TEMPLATE from "./sidebar-section-form.hbs";
let Section = (_class = (_Section_brand = /*#__PURE__*/new WeakSet(), class Section {
  constructor(_ref) {
    let {
      title,
      links,
      secondaryLinks,
      id,
      publicSection,
      sectionType,
      hideTitleInput
    } = _ref;
    _classPrivateMethodInitSpec(this, _Section_brand);
    _initializerDefineProperty(this, "title", _descriptor, this);
    _initializerDefineProperty(this, "links", _descriptor2, this);
    _initializerDefineProperty(this, "secondaryLinks", _descriptor3, this);
    this.title = title;
    this.public = publicSection;
    this.sectionType = sectionType;
    this.links = links;
    this.secondaryLinks = secondaryLinks;
    this.id = id;
    this.hideTitleInput = hideTitleInput;
  }
  get valid() {
    const allLinks = this.links.filter(link => !link._destroy).concat(this.secondaryLinks?.filter(link => !link._destroy) || []);
    const validLinks = allLinks.length > 0 && allLinks.every(link => link.valid);
    return this.validTitle && validLinks;
  }
  get validTitle() {
    return !_classPrivateGetter(_Section_brand, this, _get_blankTitle) && !_classPrivateGetter(_Section_brand, this, _get_tooLongTitle);
  }
  get invalidTitleMessage() {
    if (this.title === undefined) {
      return;
    }
    if (_classPrivateGetter(_Section_brand, this, _get_blankTitle)) {
      return I18n.t("sidebar.sections.custom.title.validation.blank");
    }
    if (_classPrivateGetter(_Section_brand, this, _get_tooLongTitle)) {
      return I18n.t("sidebar.sections.custom.title.validation.maximum", {
        count: SIDEBAR_SECTION.max_title_length
      });
    }
  }
  get titleCssClass() {
    return this.title === undefined || this.validTitle ? "" : "warning";
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "title", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "links", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "secondaryLinks", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
function _get_blankTitle(_this) {
  return isEmpty(_this.title);
}
function _get_tooLongTitle(_this2) {
  return _this2.title.length > SIDEBAR_SECTION.max_title_length;
}
let SectionLink = (_class2 = (_SectionLink_brand = /*#__PURE__*/new WeakSet(), class SectionLink {
  constructor(_ref2) {
    let {
      router,
      icon,
      name,
      value,
      id,
      objectId,
      segment
    } = _ref2;
    _classPrivateMethodInitSpec(this, _SectionLink_brand);
    _initializerDefineProperty(this, "icon", _descriptor4, this);
    _initializerDefineProperty(this, "name", _descriptor5, this);
    _initializerDefineProperty(this, "value", _descriptor6, this);
    _initializerDefineProperty(this, "_destroy", _descriptor7, this);
    this.router = router;
    this.icon = icon || "link";
    this.name = name;
    this.value = value;
    this.id = id;
    this.httpHost = "http://" + window.location.host;
    this.httpsHost = "https://" + window.location.host;
    this.objectId = objectId;
    this.segment = segment;
  }
  get path() {
    return this.value?.replace(this.httpHost, "").replace(this.httpsHost, "");
  }
  get valid() {
    return this.validIcon && this.validName && this.validValue;
  }
  get validIcon() {
    return !_classPrivateGetter(_SectionLink_brand, this, _get_blankIcon) && !_classPrivateGetter(_SectionLink_brand, this, _get_tooLongIcon);
  }
  get validName() {
    return !_classPrivateGetter(_SectionLink_brand, this, _get_blankName) && !_classPrivateGetter(_SectionLink_brand, this, _get_tooLongName);
  }
  get validValue() {
    return !_classPrivateGetter(_SectionLink_brand, this, _get_blankValue) && !_classPrivateGetter(_SectionLink_brand, this, _get_tooLongValue) && !_classPrivateGetter(_SectionLink_brand, this, _get_invalidValue);
  }
  get invalidIconMessage() {
    if (_classPrivateGetter(_SectionLink_brand, this, _get_blankIcon)) {
      return I18n.t("sidebar.sections.custom.links.icon.validation.blank");
    }
    if (_classPrivateGetter(_SectionLink_brand, this, _get_tooLongIcon)) {
      return I18n.t("sidebar.sections.custom.links.icon.validation.maximum", {
        count: SIDEBAR_URL.max_icon_length
      });
    }
  }
  get invalidNameMessage() {
    if (this.name === undefined) {
      return;
    }
    if (_classPrivateGetter(_SectionLink_brand, this, _get_blankName)) {
      return I18n.t("sidebar.sections.custom.links.name.validation.blank");
    }
    if (_classPrivateGetter(_SectionLink_brand, this, _get_tooLongName)) {
      return I18n.t("sidebar.sections.custom.links.name.validation.maximum", {
        count: SIDEBAR_URL.max_name_length
      });
    }
  }
  get invalidValueMessage() {
    if (this.value === undefined) {
      return;
    }
    if (_classPrivateGetter(_SectionLink_brand, this, _get_blankValue)) {
      return I18n.t("sidebar.sections.custom.links.value.validation.blank");
    }
    if (_classPrivateGetter(_SectionLink_brand, this, _get_tooLongValue)) {
      return I18n.t("sidebar.sections.custom.links.value.validation.maximum", {
        count: SIDEBAR_URL.max_value_length
      });
    }
    if (_classPrivateGetter(_SectionLink_brand, this, _get_invalidValue)) {
      return I18n.t("sidebar.sections.custom.links.value.validation.invalid");
    }
  }
  get iconCssClass() {
    return this.icon === undefined || this.validIcon ? "" : "warning";
  }
  get nameCssClass() {
    return this.name === undefined || this.validName ? "" : "warning";
  }
  get valueCssClass() {
    return this.value === undefined || this.validValue ? "" : "warning";
  }
  get isPrimary() {
    return this.segment === "primary";
  }
}), (_descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "icon", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "name", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "value", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "_destroy", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2);
function _get_blankIcon(_this3) {
  return isEmpty(_this3.icon);
}
function _get_tooLongIcon(_this4) {
  return _this4.icon.length > SIDEBAR_URL.max_icon_length;
}
function _get_blankName(_this5) {
  return isEmpty(_this5.name);
}
function _get_tooLongName(_this6) {
  return _this6.name.length > SIDEBAR_URL.max_name_length;
}
function _get_blankValue(_this7) {
  return isEmpty(_this7.value);
}
function _get_tooLongValue(_this8) {
  return _this8.value.length > SIDEBAR_URL.max_value_length;
}
function _get_invalidValue(_this9) {
  return _this9.path && !_assertClassBrand(_SectionLink_brand, _this9, _validLink).call(_this9);
}
function _validLink() {
  try {
    return new URL(this.value, document.location.origin);
  } catch {
    return false;
  }
}
let SidebarSectionForm = (_class3 = (_SidebarSectionForm_brand = /*#__PURE__*/new WeakSet(), class SidebarSectionForm extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _SidebarSectionForm_brand);
    _initializerDefineProperty(this, "dialog", _descriptor8, this);
    _initializerDefineProperty(this, "router", _descriptor9, this);
    _initializerDefineProperty(this, "flash", _descriptor10, this);
    _initializerDefineProperty(this, "flashType", _descriptor11, this);
    _defineProperty(this, "nextObjectId", 0);
  }
  get transformedModel() {
    const section = this.model?.section;
    if (section) {
      return new Section({
        title: section.title,
        publicSection: section.public,
        sectionType: section.section_type,
        links: section.links.reduce((acc, link) => {
          if (link.segment === "primary") {
            this.nextObjectId++;
            acc.push(this.initLink(link));
          }
          return acc;
        }, A()),
        secondaryLinks: section.links.reduce((acc, link) => {
          if (link.segment === "secondary") {
            this.nextObjectId++;
            acc.push(this.initLink(link));
          }
          return acc;
        }, A()),
        id: section.id,
        hideTitleInput: this.model.hideSectionHeader
      });
    } else {
      return new Section({
        links: A([new SectionLink({
          router: this.router,
          objectId: this.nextObjectId,
          segment: "primary"
        })])
      });
    }
  }
  initLink(link) {
    return new SectionLink({
      router: this.router,
      icon: link.icon,
      name: link.name,
      value: link.value,
      id: link.id,
      objectId: this.nextObjectId,
      segment: link.segment
    });
  }
  create() {
    return ajax(`/sidebar_sections`, {
      type: "POST",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({
        title: this.transformedModel.title,
        public: this.transformedModel.public,
        links: this.transformedModel.links.map(link => {
          return {
            icon: link.icon,
            name: link.name,
            value: link.path
          };
        })
      })
    }).then(data => {
      this.currentUser.set("sidebar_sections", this.currentUser.sidebar_sections.concat(data.sidebar_section));
      this.closeModal();
    }).catch(e => {
      this.flash = sanitize(extractError(e));
      this.flashType = "error";
    });
  }
  update() {
    this.wasPublic || this.isPublic ? _assertClassBrand(_SidebarSectionForm_brand, this, _updateWithConfirm).call(this) : _assertClassBrand(_SidebarSectionForm_brand, this, _updateCall).call(this);
  }
  get activeLinks() {
    return this.transformedModel.links.filter(link => !link._destroy);
  }
  get activeSecondaryLinks() {
    return this.transformedModel.secondaryLinks?.filter(link => !link._destroy);
  }
  get header() {
    return this.transformedModel.id ? "sidebar.sections.custom.edit" : "sidebar.sections.custom.add";
  }
  get isPublic() {
    return this.transformedModel.public;
  }
  get wasPublic() {
    return this.model?.section?.public;
  }
  focusNewRowInput(id) {
    document.querySelector(`[data-row-id="${id}"] .icon-picker summary`).focus();
  }
  setDraggedLink(link) {
    this.draggedLink = link;
  }
  reorder(targetLink, above) {
    if (this.draggedLink === targetLink) {
      return;
    }
    if (this.draggedLink.isPrimary) {
      this.transformedModel.links.removeObject(this.draggedLink);
    } else {
      this.transformedModel.secondaryLinks?.removeObject(this.draggedLink);
    }
    if (targetLink.isPrimary) {
      const toPosition = this.transformedModel.links.indexOf(targetLink);
      this.draggedLink.segment = "primary";
      this.transformedModel.links.insertAt(above ? toPosition : toPosition + 1, this.draggedLink);
    } else {
      this.draggedLink.segment = "secondary";
      const toPosition = this.transformedModel.secondaryLinks.indexOf(targetLink);
      this.transformedModel.secondaryLinks.insertAt(above ? toPosition : toPosition + 1, this.draggedLink);
    }
  }
  get canDelete() {
    return this.transformedModel.id && !this.transformedModel.sectionType;
  }
  deleteLink(link) {
    if (link.id) {
      link._destroy = "1";
    } else {
      if (link.isPrimary) {
        this.transformedModel.links.removeObject(link);
      } else {
        this.transformedModel.secondaryLinks.removeObject(link);
      }
    }
  }
  addLink() {
    this.nextObjectId = this.nextObjectId + 1;
    this.transformedModel.links.pushObject(new SectionLink({
      router: this.router,
      objectId: this.nextObjectId,
      segment: "primary"
    }));
    this.focusNewRowInput(this.nextObjectId);
  }
  addSecondaryLink() {
    this.nextObjectId = this.nextObjectId + 1;
    this.transformedModel.secondaryLinks.pushObject(new SectionLink({
      router: this.router,
      objectId: this.nextObjectId,
      segment: "secondary"
    }));
    this.focusNewRowInput(this.nextObjectId);
  }
  resetToDefault() {
    return this.dialog.yesNoConfirm({
      message: I18n.t("sidebar.sections.custom.reset_confirm"),
      didConfirm: () => {
        return ajax(`/sidebar_sections/reset/${this.transformedModel.id}`, {
          type: "PUT"
        }).then(data => {
          this.currentUser.sidebar_sections.shiftObject();
          this.currentUser.sidebar_sections.unshiftObject(data["sidebar_section"]);
          this.closeModal();
        }).catch(e => {
          this.flash = sanitize(extractError(e));
          this.flashType = "error";
        });
      },
      didCancel: () => {
        this.closeModal();
      }
    });
  }
  save() {
    this.transformedModel.id ? this.update() : this.create();
  }
  delete() {
    return this.dialog.yesNoConfirm({
      message: this.model.section.public ? I18n.t("sidebar.sections.custom.delete_public_confirm") : I18n.t("sidebar.sections.custom.delete_confirm"),
      didConfirm: () => {
        return ajax(`/sidebar_sections/${this.transformedModel.id}`, {
          type: "DELETE"
        }).then(() => {
          const newSidebarSections = this.currentUser.sidebar_sections.filter(section => {
            return section.id !== this.transformedModel.id;
          });
          this.currentUser.set("sidebar_sections", newSidebarSections);
          this.closeModal();
        }).catch(e => {
          this.flash = sanitize(extractError(e));
          this.flashType = "error";
        });
      }
    });
  }
}), (_descriptor8 = _applyDecoratedDescriptor(_class3.prototype, "dialog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, "flash", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, "flashType", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class3.prototype, "transformedModel", [cached], Object.getOwnPropertyDescriptor(_class3.prototype, "transformedModel"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "focusNewRowInput", [afterRender], Object.getOwnPropertyDescriptor(_class3.prototype, "focusNewRowInput"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "setDraggedLink", [bind], Object.getOwnPropertyDescriptor(_class3.prototype, "setDraggedLink"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "reorder", [bind], Object.getOwnPropertyDescriptor(_class3.prototype, "reorder"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "deleteLink", [bind], Object.getOwnPropertyDescriptor(_class3.prototype, "deleteLink"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "addLink", [action], Object.getOwnPropertyDescriptor(_class3.prototype, "addLink"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "addSecondaryLink", [action], Object.getOwnPropertyDescriptor(_class3.prototype, "addSecondaryLink"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "resetToDefault", [action], Object.getOwnPropertyDescriptor(_class3.prototype, "resetToDefault"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "save", [action], Object.getOwnPropertyDescriptor(_class3.prototype, "save"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "delete", [action], Object.getOwnPropertyDescriptor(_class3.prototype, "delete"), _class3.prototype)), _class3);
function _updateWithConfirm() {
  return this.dialog.yesNoConfirm({
    message: this.isPublic ? I18n.t("sidebar.sections.custom.update_public_confirm") : I18n.t("sidebar.sections.custom.mark_as_private_confirm"),
    didConfirm: () => {
      return _assertClassBrand(_SidebarSectionForm_brand, this, _updateCall).call(this);
    }
  });
}
function _updateCall() {
  return ajax(`/sidebar_sections/${this.transformedModel.id}`, {
    type: "PUT",
    contentType: "application/json",
    dataType: "json",
    data: JSON.stringify({
      title: this.transformedModel.title,
      public: this.transformedModel.public,
      links: this.transformedModel.links.concat(this.transformedModel?.secondaryLinks || []).map(link => {
        return {
          id: link.id,
          icon: link.icon,
          name: link.name,
          value: link.path,
          segment: link.segment,
          _destroy: link._destroy
        };
      })
    })
  }).then(data => {
    const newSidebarSections = this.currentUser.sidebar_sections.map(section => {
      if (section.id === data["sidebar_section"].id) {
        return data["sidebar_section"];
      }
      return section;
    });
    this.currentUser.set("sidebar_sections", newSidebarSections);
    this.closeModal();
  }).catch(e => {
    this.flash = sanitize(extractError(e));
    this.flashType = "error";
  });
}
export { SidebarSectionForm as default };
setComponentTemplate(TEMPLATE, SidebarSectionForm);